import { AuthContext } from '@/layout/Auth'

import { primary } from '@/constant'

import { UserInfo } from '@/types'

import { Avatar, Tooltip } from '@mui/material'
import React, { useContext } from 'react'
import ProfilePanel from './profilePanel'

export interface LoggedInProps {
  user: UserInfo | null
  verified: boolean
}

const LoggedInView: React.FC = () => {
  const { authInfo } = useContext(AuthContext)

  return (
    <Tooltip
      placement='bottom-end'
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: '#fff',
            boxShadow: '0px 20px 40px 0px rgba(0,28,85,0.06)',
            minWidth: '300px',
            padding: '20px',
            borderRadius: '8px',
          },
        },
        popper: {
          sx: {
            paddingRight: '24px',
            margin: '0px -24px 0px 0px !important',
          },
        },
      }}
      title={
        <ProfilePanel
          userInfo={authInfo.userInfo}
          verified={authInfo.verified}
          promotionInfo={authInfo.promotionInfo}
        />
      }
    >
      <Avatar
        variant='square'
        alt={authInfo.userInfo?.nickname ?? 'username'}
        src={authInfo.userInfo?.head_img_url}
        sx={{
          bg: primary,
          color: '#fff',
          width: 44,
          height: 44,
          borderRadius: '50%',
          cursor: 'pointer',
        }}
      />
    </Tooltip>
  )
}

export default LoggedInView
